import request from '@/utils/request'

export const reqGetImgCode = () => {
  return request({
    url: '/openApi/lwActivity/getImageCode',
    method: 'get'

  })
}
export const reqGetPhoneCode = (params) => {
  return request({
    url: '/openApi/lwActivity/smsCode',
    method: 'get',
    params

  })
}
export const reqSubmit = (data) => {
  return request({
    url: '/openApi/lwActivity/smsCode',
    method: 'post',
    data

  })
}
export const reqReservationNow = (data) => {
  return request({
    url: '/openApi/lwActivity/makeAnAppointment',
    method: 'post',
    data

  })
}

